var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex mb-4"},[_c('h2',{staticClass:"mb-0 d-flex flex-wrap align-items-center text-break"},[_vm._v(" "+_vm._s(_vm.title)+" "),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }